import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TeaserGridSimple",
    component: () => (__SERVER__ ? require("./teaser-grid-simple-view") : import("./teaser-grid-simple-view"))
});

export default definition;
